export enum MailTemplateCodes {
	FeedbackMail = 1008,
}
